import { z } from 'zod';
import { UserType } from '../user-types';
import { DateOrIsoStringSchema } from './date-or-iso';

export const AdminOkResponseSchema = z.object({ ok: z.literal(true) });

export const AdminUserFieldsSchema = z.object({
  id: z.number(),
  slackUserId: z.string(),
  ownerEmail: z.string().nullable(),
  userType: z.enum(UserType),
  teamId: z.number().nullable(),
  team: z.object({ id: z.number(), name: z.string() }).nullable(),
  copilotChannelId: z.string().nullable(),
});

export const AdminUsersResponseSchema = z.object({
  users: z.array(
    AdminUserFieldsSchema.extend({
      /** Has an owner email but no active Salesforce user matches it (GTMOPS-2836). */
      deactivatedInSfdc: z.boolean(),
      createdAt: DateOrIsoStringSchema,
      updatedAt: DateOrIsoStringSchema,
    }),
  ),
});

export const AdminUserDetailResponseSchema = AdminUserFieldsSchema.extend({
  copilotChannelName: z.string().nullable(),
  createdAt: DateOrIsoStringSchema,
  updatedAt: DateOrIsoStringSchema,
});

export const AdminUserUpdateResponseSchema = AdminUserFieldsSchema.extend({
  copilotChannelName: z.string().nullable(),
  botInChannel: z.boolean().optional(),
  botInviteError: z.string().optional(),
});

const AdminTeamUserRefSchema = z.object({
  id: z.number(),
  ownerEmail: z.string().nullable(),
  slackUserId: z.string(),
});

const AdminTeamFieldsSchema = z.object({
  id: z.number(),
  name: z.string(),
  managerId: z.number().nullable(),
  manager: AdminTeamUserRefSchema.nullable(),
  createdAt: DateOrIsoStringSchema,
  updatedAt: DateOrIsoStringSchema,
});

export const AdminTeamResponseSchema = AdminTeamFieldsSchema;

export const AdminTeamsResponseSchema = z.object({
  teams: z.array(AdminTeamFieldsSchema.extend({ memberCount: z.number(), blockCount: z.number() })),
});

export const AdminTeamArtifactBlockSchema = z.object({
  id: z.number(),
  artifactSlug: z.string(),
  reason: z.string().nullable(),
  createdAt: DateOrIsoStringSchema,
});

export const AdminTeamDetailResponseSchema = AdminTeamFieldsSchema.extend({
  members: z.array(AdminTeamUserRefSchema),
  artifactBlocks: z.array(AdminTeamArtifactBlockSchema),
});

export const AdminTeamMembersResponseSchema = z.object({
  id: z.number(),
  members: z.array(AdminTeamUserRefSchema),
});
